const taskStateOptions = {
  UNASSIGNED: "UNASSIGNED",
  ASSIGNED: "ASSIGNED",
  COMPLETED: "COMPLETED",
  CLOSED: "CLOSED",
  INVALID: "INVALID",
  PLANNED: "PLANNED",
};
export default taskStateOptions;
